import { MyLearningService } from "@root/services/my-learning";
import { useState } from "react";
import { RECORDS_PER_PAGE } from "@root/constants";

export const useMyLearning = () => {
  const [myLearningData, setMyLearningData] = useState(null);
  const [getMyLearningLoading, setGetMyLearningLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const myLearningService = new MyLearningService();

  const fetchMyLearning = async (payload?: any, page?: number) => {
    setGetMyLearningLoading(true);
    try {
      const currentPage = page !== undefined ? page : pageNo;
      // Update page state if page parameter is provided
      if (page !== undefined) {
        setPageNo(page);
      }
      const limit = RECORDS_PER_PAGE;
      const offset = (currentPage - 1) * limit;
      
      const payloadWithPagination = {
        ...payload,
        limit,
        offset,
      };
      
      const res = await myLearningService.fetchMyLearning(payloadWithPagination);
      console.log("newres", res?.data?.data?.rows);
      const data = res?.data?.data;
      setMyLearningData(data);
      setPageCount(data?.count || 0);
    } catch (error: unknown) {
      console.warn(error);
    } finally {
      setGetMyLearningLoading(false);
    }
  };

  return {
    myLearningData,
    setMyLearningData,
    fetchMyLearning,
    getMyLearningLoading,
    pageNo,
    setPageNo,
    pageCount,
  };
};
